import React from "react";
import ReactDOM from "react-dom/client";
import App from "./LoginNavigate";
import { ApolloProvider } from "@apollo/client";
import { client } from "./client";
import "./scss/main.scss";
import "react-phone-input-2/lib/style.css";
import { AppProvider } from "./context/context";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <AppProvider>
    <ApolloProvider client={client}>
      <App />
    </ApolloProvider>
  </AppProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
